import { Col, Row, Space, Flex } from "antd"
import { Title } from "ui/Typography"
import { useTranslation } from "react-i18next"
import styles from "./index.module.css"
import moment from "moment"
import { getFormattedBookingDate } from "../../utils"
import { useMemo } from "react"
import PropTypes from "prop-types"

const ExperienceDetails = ({ booking }) => {
  const { t } = useTranslation()
  const { booking_id, booked_on, guests, experience, note, reason } = booking || {}
  const { title, date, start_time, end_time, location, duration } = experience || {}

  let formattedDate = ""
  if (date) {
    formattedDate += moment(date)?.format("MM/DD/YY")
  }
  if (start_time) {
    formattedDate += (formattedDate ? " | " : "") + start_time
  }
  if (end_time) {
    formattedDate += (start_time ? " - " : " | -") + end_time
  }
  if (duration) {
    formattedDate += (formattedDate ? " | " : "") + duration
  }

  const details = useMemo(() => {
    return [
      { label: t("client.client_booking.booking_id"), value: booking_id || "" },
      { label: t("client.client_booking.experience"), value: title || "" },
      { label: t("client.client_booking.guests"), value: guests || "" },
      { label: t("client.client_booking.date"), value: formattedDate },
      { label: t("client.client_booking.address"), value: location?.address || "" },
      {
        label: t("client.client_booking.booked_on"),
        value: getFormattedBookingDate(booked_on)
      },
      { label: t("client.client_booking.notes"), value: note || "" },
      {
        label: t("client.client_booking.cancelation_reason"),
        value: reason || ""
      }
    ]
  }, [booked_on, booking_id, formattedDate, guests, location?.address, note, reason, t, title])

  return (
    <Space direction="vertical" className={`${styles.experienceDetailsContainer} w-full p-xl`}>
      <Title level={4} className="mb-l">
        {t("experiences.details.experience_details")}
      </Title>
      <Flex vertical gap={8}>
        {details
          .filter(({ value }) => value !== undefined && value !== null && value !== "")
          .map(({ label, value }) => (
            <Row key={label}>
              <Col xs={6}>{label}</Col>
              <Col xs={17} offset={1}>
                {value}
              </Col>
            </Row>
          ))}
      </Flex>
    </Space>
  )
}

ExperienceDetails.propTypes = {
  booking: PropTypes.object
}

export default ExperienceDetails
